module.exports = __webpack_public_path__ + "static/img/banner01.ed4f6d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner01.jpg
// module id = TMun
// module chunks = 1